import { useIntl } from "react-intl";
import { Message } from "src/app/types/Message";
import SimpleModal from "../SimpleModal/SimpleModal";
import ViewMessageCenterForm from "../ViewMessageCenterForm/ViewMessageCenterForm";
import { SimpleFormSelect } from "../form/SimpleFormSelect";
import { useField } from "formik";
import { useEffect } from "react";
import { ITemplatesOptions } from "src/app/hooks/useTemplatesOptions/useTemplatesOptions";

export interface IViewMessageCenterFormModal {
    entity: Message;
    handleClose?(): void;
    templatesOptions: ITemplatesOptions[];
    handleMessageFiles(filename: string): void;
    loading: boolean;
}

const ViewMessageCenterFormModal = (props: IViewMessageCenterFormModal) => {
    const { entity, handleMessageFiles, handleClose = () => {}, templatesOptions, loading } = props;

    const { formatMessage } = useIntl();

    const [templateProps] = useField("template");
    const [, , messageHelper] = useField("newMessage");
    const [, , tagHelper] = useField("tag");

    useEffect(() => {
        const template = templatesOptions.find((el) => el.value === templateProps.value);

        if (!template) return;
        let templateWithMoneySite = template.text.replaceAll("#SITE#", entity.moneySite.domain);
        templateWithMoneySite = templateWithMoneySite.replaceAll(
            "#PRICE#",
            `${entity.moneySite.price?.toString()}`
        );

        messageHelper.setValue(templateWithMoneySite);
        tagHelper.setValue(template.tag);
    }, [templateProps.value]);

    const HeaderRightComponent = (
        <div className="d-flex align-items-center justify-content-end gap-2">
            <label className="form-label">
                {formatMessage({ id: "common.field.template" })} :{" "}
            </label>
            <SimpleFormSelect values={templatesOptions} name="template" />
        </div>
    );

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.message" })}
            handleClose={handleClose}
            headerRightComponent={HeaderRightComponent}
            loading={loading}
            hasFooter={false}
            formId="message"
            showModal={true}
            modalProps={{ fullscreen: true }}
        >
            <ViewMessageCenterForm
                formId="message"
                entity={entity}
                handleMessageFiles={handleMessageFiles}
            />
        </SimpleModal>
    );
};

export default ViewMessageCenterFormModal;
